import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const NotFound = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [countdown, setCountdown] = useState(5)

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          navigate('/')
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [navigate])

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white flex items-center justify-center px-4">
      <div className="text-center max-w-md mx-auto">
        {/* 404 Number */}
        <div className="text-8xl font-bold text-pink-300 mb-4">
          404
        </div>
        
        {/* Sad Flower Icon */}
        <div className="text-6xl mb-6">
          🥀
        </div>
        
        {/* Error Message */}
        <h1 className="text-2xl font-semibold text-gray-800 mb-4">
          {t('pages.notFound.title', 'Page Not Found')}
        </h1>
        
        <p className="text-gray-600 mb-8 leading-relaxed">
          {t('pages.notFound.message', 'Sorry, the page you are looking for does not exist. It might have been moved, deleted, or you entered the wrong URL.')}
        </p>
        
        {/* Countdown and Auto-redirect Message */}
        <div className="bg-pink-50 rounded-lg p-4 mb-6">
          <p className="text-pink-700 text-sm">
            {t('pages.notFound.autoRedirect', 'Automatically redirecting to homepage in {{seconds}} seconds...', { seconds: countdown })}
          </p>
          
          {/* Progress Bar */}
          <div className="w-full bg-pink-200 rounded-full h-2 mt-3">
            <div 
              className="bg-pink-500 h-2 rounded-full transition-all duration-1000 ease-linear"
              style={{ width: `${((5 - countdown) / 5) * 100}%` }}
            ></div>
          </div>
        </div>
        
        {/* Manual Navigation Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-pink-500 hover:bg-pink-600 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
          >
            {t('pages.notFound.goHome', 'Go to Homepage')}
          </button>
          
          <button
            onClick={() => window.history.back()}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-lg transition-colors duration-200"
          >
            {t('pages.notFound.goBack', 'Go Back')}
          </button>
        </div>
        
        {/* Helpful Links */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-3">
            {t('pages.notFound.helpfulLinks', 'You might be looking for:')}
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            <button
              onClick={() => navigate('/flowers')}
              className="text-pink-600 hover:text-pink-700 text-sm underline"
            >
              {t('pages.notFound.flowersLink', 'Flowers')}
            </button>
            <span className="text-gray-300">|</span>
            <button
              onClick={() => navigate('/fruits')}
              className="text-pink-600 hover:text-pink-700 text-sm underline"
            >
              {t('pages.notFound.fruitsLink', 'Fruits')}
            </button>
            <span className="text-gray-300">|</span>
            <button
              onClick={() => navigate('/me')}
              className="text-pink-600 hover:text-pink-700 text-sm underline"
            >
              {t('pages.notFound.accountLink', 'My Account')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound 